import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'

export const styles = {
  headerStyle: {
    fontSize: 18,
    fontFamily: 'jiotype-bold',
    color: 'BLACK_21',
    lineHeight: 28,
  } as TextNewProps,
  titleText: {
    fontSize: 18,
    lineHeight: 24,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_21',
  } as TextNewProps,
  container: {
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    height: '100%',
    minHeight: 700,
  } as BoxProps,
  header: (isFileContentVisible: boolean) =>
    ({
      padding: 24,
      borderBottomWidth: 1,
      borderColor: 'DISABLED_GREY',
      flexDirection: isFileContentVisible ? 'row' : 'column',
    } as BoxProps),
  centerView: {
    alignSelf: 'center',
    flex: 1,
    width: '100%',
    justify: 'center',
  } as BoxProps,
  mainView: {
    width: '100%',
    flex: 1,
  } as BoxProps,
  innerContainer: {
    width: '100%',
    height: '100%',
  } as BoxProps,
  tabbarView: {
    position: 'absolute',
    alignSelf: 'center',
    marginLeft: 60,
  } as BoxProps,
  contnetContainer: { flex: 1, paddingTop: 40 } as BoxProps,
  backButtonContainer: {
    paddingRight: 25,
    justify: 'center',
    underlayColor: 'TRANSPARENT',
    align: 'flex-start',
  } as BoxProps,
}
